import { AutogenLayoutMultiCustomerQuickInfo } from "./autogen/AutogenLayoutMultiCustomerQuickInfo";
import { TableRowDisplayEvent, DataSourceExecutionEvent, Button } from "@mcleod/components";

export class MultiCustomerQuickInfo extends AutogenLayoutMultiCustomerQuickInfo {

    /** This is an event handler for the afterExecution event of sourceCustomer. */
    sourceCustomerAfterExecution(event: DataSourceExecutionEvent) {
        this.tableCustomers.displayData(null, event.dataSource.data, 0)
    }
}
